import React from 'react';
import { Instagram, Linkedin, Youtube } from 'lucide-react';
import { socialLinks } from '../data/mock';
import { FaTiktok } from 'react-icons/fa';
import { trackCtaClick } from '../utils/analytics';

const Social = () => {
  const socials = [
    { name: 'Instagram', icon: Instagram, url: socialLinks.instagram, cta: 'instagram' },
    { name: 'LinkedIn', icon: Linkedin, url: socialLinks.linkedin, cta: 'linkedin' },
    { name: 'YouTube', icon: Youtube, url: socialLinks.youtube, cta: 'youtube' },
    { name: 'TikTok', icon: FaTiktok, url: socialLinks.tiktok, cta: 'tiktok' }
  ];

  return (
    <section id="social" className="section-padding section-bg">
      <div className="container-custom">
        <h2 className="section-title">Presença digital</h2>
        <p className="section-description">
          Conteúdo sobre tecnologia, conectividade e inovação com dicas práticas, cases e bastidores.
        </p>
        
        <div className="social-grid">
          {socials.map((social) => {
            const IconComponent = social.icon;
            return (
              <a
                key={social.name}
                href={social.url}
                onClick={() => trackCtaClick({ cta: social.cta, location: 'social', url: social.url })}
                target="_blank"
                rel="noopener noreferrer"
                className="social-card"
                aria-label={social.name}
              >
                <IconComponent size={32} />
                <span className="social-name">{social.name}</span>
              </a>
            );
          })}
        </div>
        <div className="social-cta">
          <a href="/links" className="btn-secondary">
            Ver todos os links oficiais
          </a>
        </div>
      </div>
    </section>
  );
};

export default Social;
